import { useAppDispatch, useAppSelector } from "@app/hooks";
import { useApi } from "@services/useApi";
import { useEffect, useState } from "react";
import { UpcomingAssessment, updateCompletedAssessments } from "@store/locationsSlice";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { Colors } from "@styles/colors";
import { CompletedAssessments } from "../components/completed/CompletedAssessments";
import { AssessmentStatus } from "@store/generalTypes";
import { NoCompletedAssessments } from "../components/NoCompletedAssessments";

export const AdminAssessmentsCompleted = (): JSX.Element => {
    const [getDataLoading, setGetDataLoading] = useState(false);

    const dispatch = useAppDispatch();

    const { getAssessments } = useApi();
    const completedAssessments = useAppSelector((x) => x.orgLocations.completedAssessments?.items);

    const currentLocation = useAppSelector((x) => x.orgLocations.currentLocation);

    const handleGetCompletedAssessments = async (): Promise<void> => {
        setGetDataLoading(true);
        const assessments = await getAssessments(currentLocation!.id, false, AssessmentStatus.Complete).finally(() => {
            setGetDataLoading(false);
        });

        dispatch(updateCompletedAssessments(assessments));
    };

    useEffect(() => {
        void handleGetCompletedAssessments();
    }, [currentLocation?.id]);

    return (
        <>
            {getDataLoading ? (
                <div className="is-flex is-justify-content-center mt-4">
                    <FontAwesomeIcon icon={faSpinner} size="4x" color={Colors.darkBlue} className="fa-spin" />
                </div>
            ) : completedAssessments?.length ? (
                <CompletedAssessments
                    assessments={completedAssessments.map(
                        (x) =>
                            ({
                                examineeFirstName: x.examineeFirstName,
                                examineeLastName: x.examineeLastName,
                                id: x.id,
                                examineeEmail: x.examineeEmail,
                                examineePhoneNumber: x.examineePhoneNumber,
                                createdBy: "",
                                scheduledFor: x.date,
                                examineeId: Number(x.examineeId.split("-")[2])
                            } as UpcomingAssessment)
                    )}
                    onClick={() => {}}
                />
            ) : (
                <NoCompletedAssessments />
            )}
        </>
    );
};
